import { Form } from '@unform/web';
import styled from 'styled-components';

export const Wrapper = styled(Form)`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;

  p.MuiFormHelperText-root.Mui-error {
    margin-top: 0;
  }

  > fieldset {
    padding: 1.5rem;

    border: 1px solid rgba(0, 0, 0, 0.26);
    border-radius: 3px;

    > legend {
      text-transform: uppercase;
      padding: 0 1.5rem;
      font-size: 1rem;
      color: rgba(0, 0, 0, 0.38);
    }
  }
`;

export const InputsGroup = styled.fieldset`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1.5rem;
`;

export const InputGroupResume = styled.fieldset`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1.5rem;
`;
